<div class="flex min-h-0 flex-1 flex-col">
    <div fxLayoutAlign="space-between center" class="mb-12 shrink-0">
        <h3 class="my-0">{{ 'PAGE.CERTIFICATIONS.TITLE' | translate }}</h3>

        <app-search-outline [searchInput]="searchInput"></app-search-outline>
    </div>

    <ng-container *ngIf="!isCertificationsLoading && !isCertificationProvidersLoading; else certificationsLoadingState">
        <ng-container *ngIf="!selectedProvider; else certificationsView">
            <div class="w-100-p table-wrapper">
                <ng-container *ngIf="providerCount; else noProvidersState">
                    <mat-table #table [dataSource]="dataSource">
                        <ng-container matColumnDef="checkbox">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let provider">
                                <mat-checkbox
                                    [(ngModel)]="checkboxes[provider.id]"
                                    (ngModelChange)="toggleProviderSelection(provider)"
                                    (click)="$event.stopPropagation()"
                                >
                                </mat-checkbox>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="name">
                            <mat-header-cell class="ml-16" *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let provider">
                                <p class="text-truncate">
                                    {{ provider.providerName }}
                                </p>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="buttons">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let provider">
                                <div fxFlex="row" fxLayoutAlign="end center">
                                    <p
                                        class="text-sm font-normal text-gray-500 mr-12 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                        [class.group-hover:!opacity-0]="isActionBoxHovered"
                                    >
                                        {{ 'GENERAL.LABEL.SEE_CERTIFICATIONS' | translate }}
                                    </p>
                                    <mat-icon class="icon-18 duration-300">arrow_forward_ios</mat-icon>
                                </div>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row
                            *matRowDef="let provider; columns: displayedColumns"
                            class="relative group pointer hover:bg-gray-50"
                            matRipple
                            (click)="showCertifications(provider)"
                        ></mat-row>
                    </mat-table>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #certificationsView>
    <div class="w-100-p certifications-table-wrapper" *ngIf="certificationsDataSource && selectedProvider">
        <div class="certifications-table-header h-[58px] pl-[21px] pr-[36px] bg-lightgreybackground border-b border-b-[#E0E0E0] shrink-0" fxLayoutAlign="space-between center">
            <div fxLayoutAlign="flex-start center">
                <mat-icon class="mr-16 back-icon" svgIcon="left_chevron" (click)="goBackToProviders()"></mat-icon>
                <div>{{ selectedProvider.providerName }}</div>
            </div>
            <mat-checkbox
                [(ngModel)]="checkboxes[selectedProvider.id]"
                (ngModelChange)="toggleProviderSelection(selectedProvider, true)"
                (click)="$event.stopPropagation()"
            ></mat-checkbox>
        </div>

        <div class="certifications-table-body">
            <ng-container *ngIf="certificationCount; else noCertificationsState">
                <mat-table #table [dataSource]="certificationsDataSource">
                    <ng-container matColumnDef="name">
                        <mat-header-cell class="ml-16" *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let certification" class="pl-16">
                            <p class="text-truncate">
                                {{ certification.certificationName }}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="checkbox">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let certification">
                            <mat-checkbox
                                [(ngModel)]="certificationCheckboxes[certification.id]"
                                (ngModelChange)="toggleCertificationSelection(certification)"
                                (click)="$event.stopPropagation()"
                            >
                            </mat-checkbox>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="certificationsDisplayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let certification; columns: certificationsDisplayedColumns" class="relative pointer" matRipple></mat-row>
                </mat-table>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #certificationsLoadingState>
    <div class="table-wrapper filter-table-shimmer">
        <div class="filter-shimmer-table">
            <div class="filter-shimmer-row" *ngFor="let item of [1, 2, 3, 4, 5, 6]" fxLayout="row" fxLayoutAlign="start center">
                <div class="filter-shimmer-avatar animate mr-12"></div>
                <div class="filter-shimmer-line animate flex-1"></div>
                <div class="filter-shimmer-button animate ml-16"></div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #noProvidersState>
    <div class="users-empty-state" fxLayout="column" fxLayoutAlign="center center" *ngIf="hasActiveSearch; else noProvidersAvailableState">
        <mat-icon class="participant-view-illustration" svgIcon="search_no_results"></mat-icon>
        <h2 class="text-base mt-8 mb-0">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
        <span>{{ 'GENERAL.LABEL.TRY_SEARCH_SOMETHING_ELSE' | translate }}</span>
    </div>
</ng-template>

<ng-template #noProvidersAvailableState>
    <div class="users-empty-state" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon class="participant-view-illustration" svgIcon="opened_folder_2"></mat-icon>
        <h2 class="text-base mt-8 mb-0">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
    </div>
</ng-template>

<ng-template #noCertificationsState>
    <div class="users-empty-state" fxLayout="column" fxLayoutAlign="center center" *ngIf="hasActiveSearch; else noCertificationsAvailableState">
        <mat-icon class="participant-view-illustration" svgIcon="search_no_results"></mat-icon>
        <h2 class="text-base mt-8 mb-0">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
        <span>{{ 'GENERAL.LABEL.TRY_SEARCH_SOMETHING_ELSE' | translate }}</span>
    </div>
</ng-template>

<ng-template #noCertificationsAvailableState>
    <div class="users-empty-state" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon class="participant-view-illustration" svgIcon="opened_folder_2"></mat-icon>
        <h2 class="text-base mt-8 mb-0">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
    </div>
</ng-template>
